import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { UploadImageDialogComponent } from '../../dialogs/email/upload-dialog/upload-image-dialog.component';

@Component({
   selector: 'samweb-text-editor',
   templateUrl: './text-editor.component.html',
   styleUrls: ['./text-editor.component.scss'],
})
export class TextEditorComponent {
   @ViewChild('editor') public editor: EditorComponent;
   @ViewChild('upload') public dialog: UploadImageDialogComponent;

   @Input()
   public value: string;

   @Input()
   public smallView = false;

   @Input()
   public useTheme = false;

   @Output()
   public valueChange = new EventEmitter<string>();

   public expandToolbar: boolean;

   constructor() {}

   public open() {
      this.dialog.open();
   }

   public expand() {
      this.expandToolbar = true;
   }

   public textChanged(value) {
      this.valueChange.emit(value);
   }
}
